import React, { useState, useEffect } from "react";

// reactstrap components
import {
  DropdownToggle,
  UncontrolledDropdown,
  Card,
  CardBody,
  CardTitle,
  Progress,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import AlternativeHeader from "components/Headers/AlternativeHeader.js";
import { useNavigate } from 'react-router-dom';
import { getTotalUsers } from "api/usersApiCall";
import { getTotalInvoices } from "api/invoiceApiCall";
import { getTotalCustomers } from "api/customerApiCall";
import { getTotalProducts } from "api/productsApiCall";
import { useTranslation } from '../../../i18n/context';
import { getTotalRevenue } from "api/invoiceApiCall";
// import RevenueChart from "./RevenueChart"; // Import the new component

function Alternative() {
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalInvoice, setTotalInvoice] = useState(0);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  const [revenue, setRevenue] = useState({
    totalCommissionRevenue: 0,
    totalProductRevenue: 0,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Your existing useEffect hooks remain unchanged...
  useEffect(() => {
    const fetchTotalCustomers = async () => {
      try {
        const total = await getTotalCustomers();
        setTotalCustomers(total);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching customers:", err);
        setError('Failed to fetch total customers');
        setLoading(false);
      }
    };
    fetchTotalCustomers();
  }, []);

  const fetchTotalRevenue = async () => {
    try {
      const response = await getTotalRevenue();
      if (response && response.data) {
        setRevenue({
          totalCommissionRevenue: Number(response.data.totalCommissionRevenue) || 0,
          totalProductRevenue: Number(response.data.totalProductRevenue) || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching revenue:", error);
    }
  };

  useEffect(() => {
    fetchTotalRevenue();
  }, []);

  useEffect(() => {
    const fetchTotalInvoices = async () => {
      try {
        const total = await getTotalInvoices();
        setTotalInvoice(total);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching invoices:", err);
        setError('Failed to fetch total invoices');
        setLoading(false);
      }
    };
    fetchTotalInvoices();
  }, []);

  useEffect(() => {
    const fetchTotalUsers = async () => {
      try {
        const total = await getTotalUsers();
        setTotalUsers(total);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching users:", err);
        setError('Failed to fetch total users');
        setLoading(false);
      }
    };
    fetchTotalUsers();
  }, []);

  useEffect(() => {
    const fetchTotalProducts = async () => {
      try {
        const total = await getTotalProducts();
        setTotalProducts(total);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching products:", err);
        setError('Failed to fetch total products');
        setLoading(false);
      }
    };
    fetchTotalProducts();
  }, []);

  return (
    <>
      <AlternativeHeader />
      <Container className="mt--6" fluid>
        {/* First row with stats cards */}
        <Row>
          <Col md="6" xl="3">
            <Card className="bg-gradient-primary border-0">
              <CardBody>
                <Row>
                  <div className="col">
                    <CardTitle
                      tag="h5"
                      className="text-uppercase text-muted mb-0 text-white"
                    >
                      {t('dashboard.invoice')}
                    </CardTitle>
                    <span className="h2 font-weight-bold mb-0 text-white">
                      {totalInvoice}
                    </span>
                    <Progress
                      className="progress-xs mt-3 mb-0"
                      max="100"
                      value="30"
                      color="success"
                    />
                  </div>
                  <Col className="col-auto">
                    <UncontrolledDropdown>
                      <DropdownToggle
                        size="sm"
                        color="neutral"
                        className="mr-0"
                      >
                        <i className="fas fa-ellipsis-h" />
                      </DropdownToggle>
                    </UncontrolledDropdown>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-sm">
                  <a
                    className="text-nowrap text-white font-weight-600"
                    href="#pablo"
                    onClick={() => navigate('/admin/invoice')}
                  >
                    {t('dashboard.details')}
                  </a>
                </p>
              </CardBody>
            </Card>
          </Col>
          {/* Other stat cards remain unchanged... */}
          <Col md="6" xl="3">
            <Card className="bg-gradient-info border-0">
              <CardBody>
                <Row>
                  <div className="col">
                    <CardTitle
                      tag="h5"
                      className="text-uppercase text-muted mb-0 text-white"
                    >
                      {t('dashboard.users')}
                    </CardTitle>
                    <span className="h2 font-weight-bold mb-0 text-white">
                      {totalUsers}
                    </span>
                    <Progress
                      className="progress-xs mt-3 mb-0"
                      max="100"
                      value="30"
                      color="success"
                    />
                  </div>
                  <Col className="col-auto">
                    <UncontrolledDropdown>
                      <DropdownToggle
                        size="sm"
                        color="neutral"
                        className="mr-0"
                      >
                        <i className="fas fa-ellipsis-h" />
                      </DropdownToggle>
                    </UncontrolledDropdown>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-sm">
                  <a
                    className="text-nowrap text-white font-weight-600"
                    href="#pablo"
                    onClick={() => navigate('/admin/users')}
                  >
                    {t('dashboard.details')}
                  </a>
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col md="6" xl="3">
            <Card className="bg-gradient-danger border-0">
              <CardBody>
                <Row>
                  <div className="col">
                    <CardTitle
                      tag="h5"
                      className="text-uppercase text-muted mb-0 text-white"
                    >
                      {t('dashboard.customers')}
                    </CardTitle>
                    <span className="h2 font-weight-bold mb-0 text-white">
                      {totalCustomers}
                    </span>
                    <Progress
                      className="progress-xs mt-3 mb-0"
                      max="100"
                      value="80"
                      color="success"
                    />
                  </div>
                  <Col className="col-auto">
                    <UncontrolledDropdown>
                      <DropdownToggle
                        size="sm"
                        color="neutral"
                        className="mr-0"
                      >
                        <i className="fas fa-ellipsis-h" />
                      </DropdownToggle>
                    </UncontrolledDropdown>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-sm">
                  <a
                    className="text-nowrap text-white font-weight-600"
                    href="#pablo"
                    onClick={() => navigate('/admin/customers')}
                  >
                    {t('dashboard.details')}
                  </a>
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col md="6" xl="3">
            <Card className="bg-gradient-default border-0">
              <CardBody>
                <Row>
                  <div className="col">
                    <CardTitle
                      tag="h5"
                      className="text-uppercase text-muted mb-0 text-white"
                    >
                      {t('dashboard.products')}
                    </CardTitle>
                    <span className="h2 font-weight-bold mb-0 text-white">
                      {totalProducts}
                    </span>
                    <Progress
                      className="progress-xs mt-3 mb-0"
                      max="100"
                      value="90"
                      color="success"
                    />
                  </div>
                  <Col className="col-auto">
                    <UncontrolledDropdown>
                      <DropdownToggle
                        size="sm"
                        color="neutral"
                        className="mr-0"
                      >
                        <i className="fas fa-ellipsis-h" />
                      </DropdownToggle>
                    </UncontrolledDropdown>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-sm">
                  <a
                    className="text-nowrap text-white font-weight-600"
                    href="#pablo"
                    onClick={() => navigate('/admin/product')}
                  >
                    {t('dashboard.details')}
                  </a>
                </p>
              </CardBody>
            </Card>
          </Col>
          {/* <Col md="6" xl="3">
            <Card className="bg-gradient-warning border-0">
              <CardBody>
                <Row>
                  <div className="col">
                    <CardTitle
                      tag="h5"
                      className="text-uppercase text-muted mb-0 text-white"
                    >
                      {t('common.commission')}
                    </CardTitle>
                    <span className="h2 font-weight-bold mb-0 text-white">
                      &#x20B5;{revenue.totalCommissionRevenue.toFixed(2)}
                    </span>
                    <Progress
                      className="progress-xs mt-3 mb-0"
                      max="100"
                      value="60"
                      color="success"
                    />
                  </div>
                  <Col className="col-auto">
                    <UncontrolledDropdown>
                      <DropdownToggle size="sm" color="neutral" className="mr-0">
                        <i className="fas fa-ellipsis-h" />
                      </DropdownToggle>
                    </UncontrolledDropdown>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-sm">
                  <a
                    className="text-nowrap text-white font-weight-600"
                    href="#pablo"
                    onClick={() => navigate('/admin/revenue')}
                  >
                    {t('dashboard.details')}
                  </a>
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col md="6" xl="3">
            <Card className="bg-gradient-primary border-0">
              <CardBody>
                <Row>
                  <div className="col">
                    <CardTitle
                      tag="h5"
                      className="text-uppercase text-muted mb-0 text-white"
                    >
                      {t('common.alovroom')}
                    </CardTitle>
                    <span className="h2 font-weight-bold mb-0 text-white">
                      &#x20B5;{revenue.totalProductRevenue.toFixed(2)}
                    </span>
                    <Progress
                      className="progress-xs mt-3 mb-0"
                      max="100"
                      value="60"
                      color="success"
                    />
                  </div>
                  <Col className="col-auto">
                    <UncontrolledDropdown>
                      <DropdownToggle size="sm" color="neutral" className="mr-0">
                        <i className="fas fa-ellipsis-h" />
                      </DropdownToggle>
                    </UncontrolledDropdown>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-sm">
                  <a
                    className="text-nowrap text-white font-weight-600"
                    href="#pablo"
                    onClick={() => navigate('/admin/revenue')}
                  >
                    {t('dashboard.details')}
                  </a>
                </p>
              </CardBody>
            </Card>
          </Col> */}
        </Row>
        
        {/* Add new row for the revenue chart */}
        {/* <Row className="mt-4">
          <Col md="12" xl="12">
            <RevenueChart />
          </Col>
        </Row> */}
      </Container>
    </>
  );
}

export default Alternative;